import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const inAppNotification = createAsyncThunk(
  "inAppNotification/inAppNotification",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("notification/in-app");
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const inAppNotificationSlice = createSlice({
  name: "inAppNotification",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(inAppNotification.pending, (state) => {
        state.loading = true;
      })
      .addCase(inAppNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(inAppNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default inAppNotificationSlice.reducer;
